"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatApiErrors = formatApiErrors;
exports.formatBadRequestErrors = formatBadRequestErrors;
exports.formatValidationErrors = formatValidationErrors;
exports.toSnakeCase = toSnakeCase;
exports.fromSnakeCase = fromSnakeCase;
const lodash_1 = require("lodash");
// the profile form uses redux-form FormSections. So errors can't just be the field
// name "firstName", but have to have the form section wrapped around them:
// profile: { firstName: ['my cool error'] }
function formatApiErrors(errorsObject) {
    Object.keys(errorsObject).forEach(function (key) {
        errorsObject[key] = [errorsObject[key]];
    });
    return errorsObject;
}
function formatBadRequestErrors(errorsArray) {
    return errorsArray.reduce((acc, obj) => {
        const field = stringFromSnakeCase(obj.field);
        acc[field] = [obj.message];
        return acc;
    }, {});
}
// use this method if you are using redux-form. This will properly format the
// server side errors so they can be displayed under the form field
function formatValidationErrors(errorArray) {
    Object.keys(errorArray).forEach(function (key) {
        errorArray[key] = [errorArray[key]];
    });
    return errorArray;
}
function toSnakeCase(data) {
    return snakeCaseConversion(data, stringToSnakeCase, objectToSnakeCase);
}
function stringToSnakeCase(string) {
    return string.replace(/([A-Z])/g, (x) => '_' + x.toLowerCase());
}
function objectToSnakeCase(object) {
    if ((0, lodash_1.isArray)(object))
        return (0, lodash_1.map)(object, toSnakeCase);
    return (0, lodash_1.transform)(object, (r, v, k) => {
        r[stringToSnakeCase(k.toString())] = (0, lodash_1.isObject)(v) ? objectToSnakeCase(v) : v;
    });
}
function snakeCaseConversion(data, stringFunc, objectFunc) {
    if (!data)
        return data;
    if ((0, lodash_1.isString)(data))
        return stringFunc(data);
    if ((0, lodash_1.isObject)(data))
        return objectFunc(data);
    return data;
}
function fromSnakeCase(data) {
    return snakeCaseConversion(data, stringFromSnakeCase, objectFromSnakeCase);
}
function stringFromSnakeCase(string) {
    return string.replace(/(\_[a-z])/g, (x) => x.charAt(1).toUpperCase());
}
function objectFromSnakeCase(object) {
    if ((0, lodash_1.isArray)(object))
        return (0, lodash_1.map)(object, fromSnakeCase);
    return (0, lodash_1.transform)(object, (r, v, k) => {
        r[stringFromSnakeCase(k.toString())] = (0, lodash_1.isObject)(v) ? objectFromSnakeCase(v) : v;
    });
}
